import * as yup from "yup";
import { ValidationMessage } from "./CommonValidation";

const mmNumericPattern = /^\d+(\.\d+)?$/;

const mmField = (label) =>
    yup
        .string()
        .nullable()
        .transform((value) =>
            value == null || value === undefined ? "" : String(value)
        )
        .test("mm-group", `${label} is required`, function (value) {
            const { mm_l, mm_w, mm_h } = this.parent;
            const parts = [mm_l, mm_w, mm_h].map((v) =>
                v != null && String(v).trim() !== "" ? String(v).trim() : ""
            );
            const anyFilled = parts.some(Boolean);
            const isEdit = this.options.context?.isEdit;

            if (!anyFilled) {
                return isEdit ? true : false;
            }

            const val = value != null ? String(value).trim() : "";
            return val !== "" && mmNumericPattern.test(val);
        });

const ColorStoneValidation = yup.object().shape({
    product_title: yup.string().notRequired().trim(),
    stone_type: yup
        .string()
        .required(ValidationMessage.Field("stone type"))
        .trim(),
    shape: yup.string().required(ValidationMessage.Field("shape")).trim(),
    carat: yup
        .string()
        .required(ValidationMessage.Field("carat"))
        .matches(mmNumericPattern, "Only numeric digits and  period is allowed.")
        .trim(),
    mm_h: mmField("depth"),
    mm_l: mmField("length"),
    mm_w: mmField("width"),
    certificate: yup
        .string()
        .required(ValidationMessage.Field("certificate"))
        .trim(),
    certificate_no: yup.string().trim(),
    price: yup
        .string()
        .required(ValidationMessage.Field("price"))
        .matches(mmNumericPattern, "Only numeric digits and  period is allowed.")
        .trim(),
    stock_number: yup
        .string()
        .required(ValidationMessage.Field("stock number"))
        .trim(),
    images: yup
        .mixed()
        .nullable()
        .test(
            "required",
            "Please upload at least one image.",
            function (file) {
                if (this.options.context?.hasExistingImages) {
                    return true;
                }
                if (file == null || file === "") {
                    return false;
                }
                if (typeof file === "object" && file.length === 0) {
                    return false;
                }
                return true;
            }
        )
        .test(
            "fileType",
            ValidationMessage?.UNSUPPORTED + " Please choose jpg, jpeg and png",
            (file) => {
                if (file?.length > 0 && file[0]?.type) {
                    return ["image/jpeg", "image/png", "image/jpg"].includes(
                        file[0]?.type
                    );
                }
                return true;
            }
        ),
    video: yup.string().notRequired(),
    comment: yup.string().notRequired().trim(),
});

export default ColorStoneValidation;
